import React from 'react'
import styled from 'styled-components';
// import GithubCalender from "../../Assets/GitHubCalender.png";
import { device } from '../../responsive/device';
import GithubCalender from 'react-github-graph';

export const Title = styled.h1`
  font-size: 6.4rem;
  font-weight: 900;
  color: white;
  text-align : center;
  margin : auto;
  margin-bottom : 15px;
  @media ${device.mobileL} {
    font-size: 3rem;
  }
  @media ${device.mobileS} {
    font-size: 2rem;
  }`

  export const Container = styled.div`
  height: 100%;
  width: 100vw;
  padding: 2rem 0 2rem 0;
  overflow-x: hidden;
  margin : auto;
  margin-bottom: 8rem;
  display : flex;
  align-items : center;
  flex-direction : column;
`;

// export const Image = styled.img`
//   border : 1px solid #8685e8;
//   border-radius : 12px;
//   width : 100%;
//   margin : auto
//   @media ${device.mobileL} {
//     font-size: 4rem;
//   }
//   @media ${device.mobileS} {
//     font-size: 3rem;
//   }`

  export const Calender = styled.div`
  color :#D83A7C ;
   background-color : #141321 ;
    border : 1px solid white ;
    border-radius : 3px ;
     padding : 25px;
     @media ${device.mobileL} {
      padding : 5px;
    }
    @media ${device.mobileS} {
      padding : 5px;
    }
  `

  export const StatsDiv = styled.div`
   display : flex ;
   margin : auto ;
   margin-top : 20px ;
   gap : 2%;
   @media ${device.mobileL} {
    flex-direction : column;
    gap : 15px;
  }
  @media ${device.mobileS} {
    flex-direction : column;
    gap : 15px;
  }
  `

export const StatsImg = styled.img`
  height : 190px;
  @media ${device.mobileL} {
    height : 100px;
  }
  @media ${device.mobileS} {
    flex-direction : column;
    height : 70px;
  }
`

const GitHub = () => {
  return (
    <Container>
        <Title>GitHub Stats</Title>
        {/* <a href='https://github.com/JaiminSheladiya' target='_blank'> */}
        {/* <Image src={GithubCalender} /> */}
        <Calender className='calender'>
        <GithubCalender username='JaiminSheladiya' style={{color : 'white'}} />
        </Calender>



        <StatsDiv style={{marginTop : '20px'}}>
  <StatsImg align="center" cursor='none' src="https://github-readme-stats.vercel.app/api?username=JaiminSheladiya&count_private=true&theme=radical&show_icons=true" />
  
  <StatsImg align="center" cursor='none' src="https://github-readme-streak-stats.herokuapp.com/?user=JaiminSheladiya&theme=radical&hide_border=false" />
        </StatsDiv>
        {/* </a> */}
    </Container>
  )
}

export default GitHub